import CoreUI from "~/core-ui/ts/CoreUI";

import "~/operatorApplication/scss/index.scss";
import operatorApplicationRouter from "~/operatorApplication/ts/router/OperatorApplicationRouter";
import OperatorApplicationRoot from "~/operatorApplication/vue/OperatorApplicationRoot.vue";
import {
    OperatorApplicationShortcutsInstance
} from "~/operatorApplication/ts/service/shortcuts/OperatorApplicationShortcuts";
import {OperatorApplicationConfigInstance} from "~/operatorApplication/ts/service/OperatorApplicationConfig";
import {StorageInstance} from "~/ts/library/storage/StorageFactory";
import OperatorApplicationPlatform from "~/operatorApplication/ts/platform/OperatorApplicationPlatformFactory";
import OperatorApplicationStatusNotifier
    from "~/operatorApplication/ts/service/operators/OperatorApplicationStatusNotifier";
import OperatorApiRequestFactory from "~/operatorApplication/ts/request/OperatorApiRequestFactory";
import OperatorApiRequest from "~/operatorApplication/ts/request/OperatorApiRequest";
import LcabApiRequestFactory from "~/cabinet/ts/api/LcabApiRequestFactory";
import LcabApiRequestFromOperatorApplication from "~/cabinet/ts/api/LcabApiRequestFromOperatorApplication";
import AbstractActionDescription from "~/cabinet/ts/data/events/AbstractActionDescription";
import {
    DataProviderEntitySaveActionDescription
} from "~/cabinet/ts/data/events/actionDescriptions/DataProvider/DataProviderEntitySaveActionDescription";
import UploadHelperFactory from "~/ts/library/UploadHelperFactory";
import OperatorApplicationUploadHelper from "~/operatorApplication/ts/request/OperatorApplicationUploadHelper";

OperatorApiRequestFactory.setClass(OperatorApiRequest);
LcabApiRequestFactory.setClass(LcabApiRequestFromOperatorApplication);
UploadHelperFactory.setClass(OperatorApplicationUploadHelper);

AbstractActionDescription.setDiscriminator({
    dataProviderEntitySave: DataProviderEntitySaveActionDescription
});

StorageInstance.setPrefix("operatorApplication");
OperatorApplicationConfigInstance.init(OperatorApplicationPlatform.isNative);

let coreUI = new CoreUI(OperatorApplicationRoot, operatorApplicationRouter);

coreUI.createApp();

OperatorApplicationShortcutsInstance.init();
OperatorApplicationStatusNotifier.init();